import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import Auth from '../api/auth';

const ReRoute = () => {
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    if (location.pathname && location.pathname === '/checkout' && Auth.isLoggedIn()) {
      history.push({
        pathname: '/select-account',
      });
    }
  }, []);

  return null;
};

export default ReRoute;
